// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y1y-","type":"styles_type__3Onik","choices":"styles_choices__2HLbJ"};